import { type Observable, of } from 'rxjs';
import { catchError, exhaustMap, filter, map, mergeMap } from 'rxjs/operators';

import { type Actions as RootActions } from '../actions';
import { setAuthRedirectPath } from '../shared/authRedirect';

import { Actions, ActionTypes } from './actions';
import { authServices } from './services';

export const checkingAuth = (action$: Observable<RootActions>) =>
  action$.pipe(
    filter(
      (action): action is Extract<RootActions, { type: ActionTypes.CHECKING_AUTH }> =>
        action.type === ActionTypes.CHECKING_AUTH,
    ),
    // exhaustMap: checkingAuth is dispatched from both index.tsx (module
    // level, to resolve auth before React mounts) and WithAuth's effect.
    // With mergeMap the overlap produced two concurrent caller-identity
    // calls; exhaustMap ignores re-checks while one is already in flight.
    exhaustMap(() =>
      authServices.checkAuth().pipe(
        map((response) => Actions.signedIn(response, response.scopes)),
        catchError(() => of(Actions.signIn())),
      ),
    ),
  );

export const signIn = (action$: Observable<RootActions>) =>
  action$.pipe(
    filter(
      (action): action is Extract<RootActions, { type: ActionTypes.SIGN_IN }> => action.type === ActionTypes.SIGN_IN,
    ),
    map(() => {
      setAuthRedirectPath();
      authServices.signIn();
      return Actions.signingIn();
    }),
  );

export const signOut = (action$: Observable<RootActions>) =>
  action$.pipe(
    filter(
      (action): action is Extract<RootActions, { type: ActionTypes.SIGN_OUT }> => action.type === ActionTypes.SIGN_OUT,
    ),
    mergeMap(() =>
      authServices.signOut().pipe(
        map(() => Actions.signedOut()),
        catchError(() => of(Actions.signedOut())),
      ),
    ),
  );
